import { render } from "./InfosTag.vue?vue&type=template&id=7083c0c6&scoped=true"
import script from "./InfosTag.vue?vue&type=script&lang=js"
export * from "./InfosTag.vue?vue&type=script&lang=js"

import "./InfosTag.vue?vue&type=style&index=0&id=7083c0c6&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7083c0c6"]])

export default __exports__